import { setData } from 'src/utils/app-storage';
import { API_IDENTIFICATION_CODE } from 'src/utils/constants/localStorageConstants';

import {
  B2BAPI_COUNTRY_URL,
  SINGLE_LAUNCH_API,
  AUTH_BASE_ADDRESS,
  PLAN_API_URL,
  GWAPI_UPNEXT_URL,
  SINGLEPLAY_URL,
  TRUECALLER_WEB_STATUS,
  TRUECALLER_UPDATE,
  TRUECALLER_WEB_REGISTER,
  RENTAL_PURCHASES,
  SUBSCRIPTION_PLAN_API,
  PAY_BASE_URL1,
  GET_REFERRAL_SHARE_LINK_URL,
  TVOD_PURCHASE_PLAN_URL,
  SPAPI_ADS_URL,
  CLOUDINARY_IMAGE_URL,
  GRAPHQL_ENDPOINT,
  REFERRAL_BASE_ADDRESS,
  SUBSCRIPTION_API_URL,
  PROMO_CODE_API_URL,
  POLICIES_API,
  ADD_AND_REMOVE_DEVICE,
  GWAPI_GET_WATCHLIST_URL,
  CONTENT_LITE_API_URL,
  GET_MOVIE_SEO_PAGE_URL,
  SETTINGS_API_URL,
  DATA_COLLECTION,
  SETTINGS,
  USER_API,
  AGGREGATED_USER_BASE_ADDRESS,
  WATCH_HISTORY_BASE_ADDRESS,
  GET_USER_TOKEN
} from '../../../utils/constants/ApiConstants';

export const getResponseBodyErrorCode = (responseData: unknown): number => {
  let responseHttpStatusCode: number;

  if (responseData) {
    responseHttpStatusCode = 1001;
  } else {
    responseHttpStatusCode = 1002; // EMPTY RESPONSE
  }
  return responseHttpStatusCode;
};

interface API_LIST {
  [arg: string]: string | undefined;
}

export const getKeyByValue = (value: string) => {
  const apiList: API_LIST = API_LIST;
  return (
    apiList &&
    (Object.keys(apiList).find((key: string) =>
      value?.includes(apiList[key] as string)
    ) ??
      'NA')
  );
};

export const API_ERROR_CODES = {
  SLA: 'LA',
  GWAPI: 'GW',
  SPAPI: 'SP',
  CONTENTAPI: 'CO',
  CLOUDINARYAPI: 'CL',
  LOGGEDINUSERSAPI: 'UB',
  REFERRALAPI: 'REF',
  GRAPHQLAPI: 'GRQ',
  AUTHAPI: 'AU',
  SUBSCRIPTIONAPI: 'SU',
  USERACTIONBASEADDRESSAPI: 'AUB',
  DEVICEAPI: 'DC',
  PLAN_API_URL: 'OM',
  TVOD_PURCHASE_PLAN_URL: 'TPP',
  WATCH_HISTORY_BASE_ADDRESS: 'WH',
  B2BAPI_COUNTRY_URL: 'XC', // For CountryApi
  NA: 'NA'
} as const;

interface errorapi {
  [key: string]: string;
}
export const API_ERROR: errorapi = {
  // AUTHAPI
  AUTH_BASE_ADDRESS: API_ERROR_CODES.AUTHAPI,
  SINGLE_LAUNCH_API: API_ERROR_CODES.SLA,
  TVOD_PURCHASE_PLAN_URL: API_ERROR_CODES.TVOD_PURCHASE_PLAN_URL,
  GET_USER_TOKEN: API_ERROR_CODES.AUTHAPI,

  //SPAPI
  SPAPI_ADS_URL: API_ERROR_CODES.SPAPI,
  SINGLEPLAY_URL: API_ERROR_CODES.SPAPI,

  //Cloudinary API
  CLOUDINARY_IMAGE_URL: API_ERROR_CODES.CLOUDINARYAPI,

  //GraphQl API
  GRAPHQL_ENDPOINT: API_ERROR_CODES.GRAPHQLAPI,

  // Referral API
  GET_REFERRAL_SHARE_LINK_URL: API_ERROR_CODES.REFERRALAPI,
  REFERRAL_BASE_ADDRESS: API_ERROR_CODES.REFERRALAPI,

  //Subscription API
  SUBSCRIPTION_API_URL: API_ERROR_CODES.SUBSCRIPTIONAPI,
  PROMO_CODE_API_URL: API_ERROR_CODES.SUBSCRIPTIONAPI,
  RENTAL_PURCHASES: API_ERROR_CODES.SUBSCRIPTIONAPI,

  //
  POLICIES_API: API_ERROR_CODES.USERACTIONBASEADDRESSAPI,

  //Device API
  ADD_AND_REMOVE_DEVICE: API_ERROR_CODES.DEVICEAPI,

  //Content API
  CONTENT_API_GET_TOP_SEARCH: API_ERROR_CODES.CONTENTAPI,

  //gwapi
  GWAPI_GET_WATCHLIST_URL: API_ERROR_CODES.GWAPI,
  CONTENT_LITE_API_URL: API_ERROR_CODES.GWAPI,
  GET_MOVIE_SEO_PAGE_URL: API_ERROR_CODES.GWAPI,
  GWAPI_UPNEXT_URL: API_ERROR_CODES.GWAPI,

  //LoggedIn User
  SETTINGS_API_URL: API_ERROR_CODES.LOGGEDINUSERSAPI,
  DATA_COLLECTION: API_ERROR_CODES.LOGGEDINUSERSAPI,
  SETTINGS: API_ERROR_CODES.LOGGEDINUSERSAPI,
  USER_API: API_ERROR_CODES.LOGGEDINUSERSAPI,
  AGGREGATED_USER_BASE_ADDRESS: API_ERROR_CODES.LOGGEDINUSERSAPI,

  //For countryApi
  B2BAPI_COUNTRY_URL: API_ERROR_CODES.B2BAPI_COUNTRY_URL,

  // WATCHHISTORY
  WATCH_HISTORY_BASE_ADDRESS: API_ERROR_CODES.WATCH_HISTORY_BASE_ADDRESS,
  NA: API_ERROR_CODES.NA
};

export const API_LIST = {
  AUTH_BASE_ADDRESS,
  B2BAPI_COUNTRY_URL,
  SINGLE_LAUNCH_API,
  GWAPI_UPNEXT_URL,
  SINGLEPLAY_URL,
  GET_REFERRAL_SHARE_LINK_URL,
  TRUECALLER_WEB_STATUS,
  TRUECALLER_UPDATE,
  TRUECALLER_WEB_REGISTER,
  RENTAL_PURCHASES,
  SUBSCRIPTION_PLAN_API,
  TVOD_PURCHASE_PLAN_URL,
  PAY_BASE_URL1,
  PLAN_API_URL,
  SPAPI_ADS_URL,
  CLOUDINARY_IMAGE_URL,
  GRAPHQL_ENDPOINT,
  REFERRAL_BASE_ADDRESS,
  SUBSCRIPTION_API_URL,
  PROMO_CODE_API_URL,
  POLICIES_API,
  ADD_AND_REMOVE_DEVICE,
  GWAPI_GET_WATCHLIST_URL,
  CONTENT_LITE_API_URL,
  GET_MOVIE_SEO_PAGE_URL,
  SETTINGS_API_URL,
  DATA_COLLECTION,
  SETTINGS,
  USER_API,
  AGGREGATED_USER_BASE_ADDRESS,
  WATCH_HISTORY_BASE_ADDRESS,
  GET_USER_TOKEN
};

export interface CreateCustomErrorObjParams {
  responseBodyErrorCode: number;
  apiIdentificationCode: string;
  api: string;
  requestMethod: string;
  requestBody: { [key: string]: string };
  responseData: unknown;
}

export const createCustomErrorObj = ({
  apiIdentificationCode,
  api,
  requestMethod,
  requestBody,
  responseData
}: CreateCustomErrorObjParams) => {
  if (requestBody) {
    Object.keys(requestBody).forEach((key) => {
      if (key.toLowerCase().indexOf('token') > -1) {
        delete requestBody[key];
      }
    });
  }
  const customErrorObj = {
    apiName: api,
    context: 'response',
    apiIdentificationCode,
    requestMethod,
    requestBody: requestBody ?? '',
    responseData: responseData ?? ''
  };
  return customErrorObj;
};

export const storeApiIdentificationName = (apiIdentificationCode: string) => {
  setData(API_IDENTIFICATION_CODE, apiIdentificationCode);
};

export const GQL_QUERIES = {
  PARTNER_SETTINGS: 'PS',
  FETCH_COLLECTION_QUERY: 'FCQ',
  FETCH_CONTENT_DETAILS_DATA_QUERY: 'FCDDQ',
  CONTENT_TVSHOW_QUERY: 'CTQ',
  FETCH_LATEST_MOVIES_DATA_QUERY: 'FLMDQ',
  FETCH_MOVIE_DATA_QUERY: 'FMODQ',
  FETCH_MUSIC_DATA_QUERY: 'FMVDQ',
  RECOMMENDED_MOVIES_QUERY: 'RMQ',
  REFRESH_AUTH_TOKEN_QUERY: 'RATQ',
  SEARCH_SUGGESTION_QUERY: 'SSQ',
  SEARCH_RESULT_QUERY: 'SRQ',
  FETCH_SIMILAR_CONTENTS_QUERY: 'FSCQ',
  FETCH_SIMILAR_CONTENTS_QUERY_FOR_BOT_REQUEST: 'FSCQFBR',
  FETCH_PERSONALISED_CONTENT_QUERY: 'PCONTENT',
  FETCH_SUBSCRIPTION_BANNER_QUERY: 'FSBQ',
  FETCH_TVSHOW_RELAVANT_CONTENTS_QUERY: 'FTRCQ',
  FETCH_EPISODES_QUERY: 'FEQ',
  FETCH_UP_NEXT_EPISODES: 'FUNE',
  USER_EXISTS_QUERY: 'UEQ',
  SEND_OTP_QUERY: 'SOQ',
  VERIFY_OTP_QUERY: 'VOQ',
  VERIFY_OTP_REGISTER_QUERY: 'VORQ',
  CELEBS_QUERY: 'CQ',
  SEARCH_LANDING_QUERY: 'SLQ',
  WATCH_LIST: 'WL',
  ADD_TO_WATCH_LIST: 'ATW',
  DELETE_FROM_WATCHLIST: 'DFW',
  DEVICE_MANAGEMENT_QUERY: 'DMQ',
  SEARCH_RESULT_RAILS_QUERY: 'SRRQ',
  ADS_STACK_QUERY: 'ASQ',
  FETCH_TEAMS_QUERY: 'FTQ'
};
